(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('ganttChart', ganttChart);
	
	ganttChart.$inject = ['$scope', '$rootScope', '$state', '$location',  '$timeout', 'GanttObjectModel', 'ganttDebounce',
		'moment', 'leanFilterService', 'viewProjectsService', 'editProjectService', 'redirectParamsService', 'storeService', 'tableService', '$experiments'];
	
	function ganttChart($scope, $rootScope, $state, $location, $timeout, ObjectModel, debounce,
			moment, leanFilterService, viewProjectsService, editProjectService, redirectParamsService, storeService, tableService, $experiments) {
		var vm = this;
		var unsubscribe;
		$scope.filterService = leanFilterService;

		var colorMap = {
			'30-bad': '#F7B6C4', // radar light
			'20-warn': '#FFE349', // yellow500 (old palette)
			'10-good': '#C1DAB4', // earth light
			'complete': '#96D0FB' // booster tint
		};
		var colorClassMap = {
			'30-bad': 'bad',
			'20-warn': 'warn',
			'10-good': 'good',
			'complete': 'complete'
		};

		//Set correct navigation highlighting
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		var viewLink = '/application/f/home.html#/lean-projects/edit-project?fromLocation=gantt-chart&projectNdx=';
		var reportSettingsName = 'projects-gantt';
		vm.stageList = [];
		vm.reportName = 'Gantt chart (Lean projects)';
		vm.dataLoad = false;

		var extraParams = [{}];

		var defaultFilters = [
			{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true },
			{ 'id': 'projectArea', 'values': [$scope.filterService.leanDnaAllSelected] },
			{ 'id': 'timePeriod', 'values': ['current'] }
		];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			extraParams: extraParams,
			waitForFilters: true,
			defaultFilters: defaultFilters,
			hideSearch: true
		};
	
		vm.getData = getData;
		vm.getMeta = getMeta;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = vm.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
		
		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function getMeta() {
			return meta;
		}

		function getData() {
			vm.dataLoad = true;

			var factoryNdxString = leanFilterService.getFactoryList();
			tableService.trackPageView(reportSettingsName, factoryNdxString);
			if (reportSettingsName === globalReportName || reportSettingsId === globalReportName) {
				viewProjectsService.getData(true, true, 'Gantt').then(function(data) {
					var list = [];
					if (data && data.data) {
						list = data.data;
					}
					organizeProjects(list);
				});
			}
		};

		function init() {
			$scope.filterService.clearFilters();
			$scope.useFactoryFilter = true;
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			$scope.filterService.setMasterFilterList([
				$scope.filterService.filterDefinitions.BusinessUnit,
				siteFilter,
				$scope.filterService.filterDefinitions.ProjectArea,
				$scope.filterService.filterDefinitions.ProjectStageAll,
				$scope.filterService.filterDefinitions.ProjectCategories,
				$scope.filterService.filterDefinitions.ProjectTypes,
				$scope.filterService.filterDefinitions.ProjectGoals,
				$scope.filterService.filterDefinitions.ProjectManager
			]);
			$scope.filterService.setMasterSingleSelectFilterList([]);
			$scope.filterService.setMasterRangeFilterList([
				$scope.filterService.filterDefinitions.TimePeriod
			]);
		}
		
		init();
		var objectModel;
		
		vm.options = {
			dateFormat: 'MMM D, YYYY',
			mode: 'custom',
			scale: 'month',
			sortMode: undefined,
			sideMode: 'Table',
			daily: false,
			maxHeight: false,
			width: true,
			zoom: 1,
			columns: ['model.name', 'model.projectManager'],
			treeTableColumns: ['from', 'to'],
			columnsHeaders: {'model.name' : 'Name', 'model.projectManager': 'Project Manager'},
			columnsClasses: {'model.name' : 'gantt-column-name', 'model.projectManager' : 'gantt-column-project-manager'},
			columnsFormatters: {
				'from': function(from) {
					return from !== undefined ? from.format('lll') : undefined;
				},
				'to': function(to) {
					return to !== undefined ? to.format('lll') : undefined;
				}
			},
			treeHeaderContent: '{{getHeader()}}',
			columnsHeaderContents: {'model.name': '{{getHeader()}}', 'model.projectManager': '{{getHeader()}}'},
			rowContentEnabled: true,
			autoExpand: 'true',
			taskOutOfRange: 'truncate',
			fromDate: moment(null),
			toDate: undefined,
			rowContent: '<span title="{{row.model.name}}"><a href="' + viewLink + '{{row.model.projNdx + \'&factoryNdx=\' + row.model.leanDirFactoryNdx}}">{{row.model.name}}</a></span>',
			taskContent : '<i class="fa fa-tasks"></i> {{task.model.name}}',
			allowSideResizing: true,
			labelsEnabled: true,
			currentDate: 'line',
			currentDateValue: new Date(),
			draw: false,
			readOnly: false,
			api: function(api) {
				// API Object is used to control methods and events from angular-gantt.
				vm.api = api;
			
				api.core.on.ready($scope, function() {
					api.data.on.load($scope, function() {
						api.columns.generate();
					});
					api.side.setWidth(300);
					
					api.tasks.on.rowChange($scope, function(task) {
						updateTask(task.row.model);
					});
					
					api.tasks.on.change($scope, function(task) {
						$scope.live.row = task.row.model;
						updateTask(task.row.model);
					});
					api.side.on.resizeEnd($scope, function(width){
						if (width > 290) {
							var newWidth = width - 290;
							newWidth = newWidth / 3;
							jQuery('.gantt-column-name').css('width', 170 + (newWidth * 2));
							jQuery('.gantt-column-project-manager').css('width', 120 + newWidth);
						}
					});

					objectModel = new ObjectModel(api);
				});
			}
		};
		// Visual two way binding.
		$scope.live = {};

		var debounceValue = 10;


		function updateTask(taskJson) {
			if (taskJson !== undefined && taskJson.tasks !== undefined && taskJson.tasks.indexOf($scope.live.task) < 0) {
				$scope.live.task = taskJson.tasks[0];
				saveProjectDates($scope.live.task);
			}
		};

		var listenRowJson = debounce(function(rowJson) {
			if (rowJson !== undefined) {
				var row = angular.fromJson(rowJson);
				objectModel.cleanRow(row);
				var tasks = row.tasks;
			
				delete row.tasks;
				delete row.drawTask;
			
				var rowModel = $scope.live.row;
			
				angular.extend(rowModel, row);
			
				var newTasks = {};
				var i, l;
			
				if (tasks !== undefined) {
					for (i = 0, l = tasks.length; i < l; i++) {
						objectModel.cleanTask(tasks[i]);
					}
				
					for (i = 0, l = tasks.length; i < l; i++) {
						newTasks[tasks[i].id] = tasks[i];
					}
				
					if (rowModel.tasks === undefined) {
						rowModel.tasks = [];
					}
					for (i = rowModel.tasks.length - 1; i >= 0; i--) {
						var existingTask = rowModel.tasks[i];
						var newTask = newTasks[existingTask.id];
						if (newTask === undefined) {
							rowModel.tasks.splice(i, 1);
						} else {
							objectModel.cleanTask(newTask);
							angular.extend(existingTask, newTask);
							delete newTasks[existingTask.id];
						}
					}
				} else {
					delete rowModel.tasks;
				}
			
				angular.forEach(newTasks, function(newTask) {
					rowModel.tasks.push(newTask);
				});
			}
		}, debounceValue);
		
		$scope.$watch('live.rowJson', listenRowJson);

		$scope.$watchCollection('live.task', function(task) {
			$scope.live.taskJson = angular.toJson(task, true);
			$scope.live.rowJson = angular.toJson($scope.live.row, true);
		});

		$scope.$watchCollection('live.row', function(row) {
			$scope.live.rowJson = angular.toJson(row, true);
			if (row !== undefined && row.tasks !== undefined && row.tasks.indexOf($scope.live.task) < 0) {
				$scope.live.task = row.tasks[0];
			}
		});

		$scope.$watchCollection('live.row.tasks', function() {
			$scope.live.rowJson = angular.toJson($scope.live.row, true);
		});
		
		$scope.canAutoWidth = function(scale) {
			return !(scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/));

		};
		
		$scope.getColumnWidth = function(widthEnabled, scale, zoom) {
			if (!widthEnabled && $scope.canAutoWidth(scale)) {
				return undefined;
			}
			
			if (scale.match(/.*?week.*?/)) {
				return 150 * zoom;
			}
			
			if (scale.match(/.*?month.*?/)) {
				return 80 * zoom;
			}
			
			if (scale.match(/.*?quarter.*?/)) {
				return 500 * zoom;
			}
			
			if (scale.match(/.*?year.*?/)) {
				return 800 * zoom;
			}

			return 40 * zoom;
		};
			
		function canEditProjectDate(stage, projectManagerNdx, adminNdx, creatorNdx, userIsApprover) {
			if (stage === 'Archive') {
				return false;
			}
			if (globalConfig.user.authFacts[globalConfig.factory.id].profileType === 'SystemAdministrator' ||
					globalConfig.user.authFacts[globalConfig.factory.id].profileType === 'SuperSystemAdministrator' ||
					globalConfig.user.authFacts[globalConfig.factory.id].initAuthz ||
					userIsApprover === 1) {
				return true;
			}
			var adminNdxList = [];
			if (adminNdx && adminNdx.length) {
				adminNdxList = adminNdx.split(',');
			}
			if (stage == 'Pending Approval') {
				return globalConfig.user.id == creatorNdx;
			}
			return globalConfig.user.id == projectManagerNdx || 
				adminNdxList.indexOf('' + globalConfig.user.id) > 0;
		}
		
		function organizeProjects(pList) {
			vm.projectData = pList;
			var projects = [];
			angular.forEach(pList, function(proj, index) {
				var isActionAllowed = canEditProjectDate(proj.stageName, proj.projectManagerNdx, proj.adminNdx, proj.creatorNdx, proj.userIsApprover);
				var projectStatus = proj.completeFlag && proj.stageSequence != 1000 ? 'complete' : proj.status;
				projects.push({
					name: proj.name, 
					projNdx: proj.projNdx,
					leanDirFactoryNdx: proj.leanDirFactoryNdx,
					projectManager: proj.projectManager,
					tasks: [
						{
							dataNdx: index,
							projNdx: proj.projNdx,
							name: proj.name,
							leanDirFactoryNdx: proj.leanDirFactoryNdx,
							from: new Date(proj.startDate), 
							to: new Date(proj.dueDate),
							color: colorMap[projectStatus],
							classes: [colorClassMap[projectStatus], isActionAllowed ? 'movable' : ''],
							'movable': {
								'enabled': isActionAllowed,
								'allowMoving': isActionAllowed,
								'allowResizing': isActionAllowed,
								'allowRowSwitching': false
							}
						}
					]
				});
			});

			vm.data = projects;
			vm.dataLoad = false;
		}
		
		function updateLastModified(project) {
			editProjectService.getLastModified(project.projNdx, project.leanDirFactoryNdx)
				.then(function(data) {
					if (data && data[0]) {
						vm.projectData[project.dataNdx].lastModified = data[0].lastModified;
					}
				});
		}
		
		function saveProjectDates(projectModal) {
			if (!vm.dataLoad) {
				var saveObj = {};
				saveObj.id = projectModal.projNdx;
				saveObj['startDate'] = moment(projectModal.from)._d;
				saveObj['endDate'] = moment(projectModal.to)._d;
				viewProjectsService.saveProject(saveObj, projectModal.leanDirFactoryNdx, (new Date(vm.projectData[projectModal.dataNdx].lastModified)).toUTCString())
					.then(function (response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {
								'message': 'Project dates was saved successfully',
								'success': true
							});
							updateLastModified(projectModal);
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {
								'message': errorMessage,
								'success': false
							});
						} else {
							$rootScope.$emit('toast', {
								'message': 'Unexpected server error',
								'success': false
							});
						}
					});
			}
		} 
	}
})();
